<div class="membership-packages-div">
  <div class="wow-plane-main">
    <div class="membership-packages-filter row">
      <div class="membership-packages-filter-family col-md-6 col-sm-12 col-xs-12">
        <div class="member d-flex align-items-center">
          <span style="color:#999999">This plan includes:</span>
          <span>{{ selectedPlanForLabel }}</span>
        </div>

        <span (click)="open()" class="modal-btn" data-bs-toggle="modal" data-bs-target="#exampleModal">
          <img width="12" style="margin-bottom: 3px" src="{{ sharedService.imagesUrl }}icons/edit.svg" alt="">
          Add Family
        </span>
      </div>
      <div *ngIf="!hideFrequency" class="membership-packages-filter-duration col-md-3 col-sm-12 col-xs-12" [ngClass]="{'monthly': pricingType?.toLowerCase() == 'monthly',
      'yearly': pricingType?.toLowerCase() == 'yearly',
    }">
        <span class="montahly" (click)="setPricingType('monthly')"
          [ngClass]="{ 'selected': pricingType?.toLowerCase() == 'monthly' }">
          Monthly
        </span>
        <span class="yearly" (click)="setPricingType('yearly')" [ngClass]="{
          'selected': pricingType?.toLowerCase() == 'yearly',
          'disabled-yearly': selectedMembership?.name == 'Comprehensive'
        }">
          Yearly
        </span>
      </div>
      <div *ngIf="!isDiscounted"
        [ngStyle]="{'opacity': pricingType?.toLowerCase() == 'monthly' || selectedMembership?.name == 'Comprehensive'? 0.3 : 1}"
        class="save15-mobile membership-packages-filter-description col-md-3 col-sm-12 col-xs-12">
        <img width="16" height="16" style="margin-bottom: 3px;margin-right: 8px;"
          src="{{ sharedService.imagesUrl }}icons/{{pricingType?.toLowerCase() == 'monthly' || selectedMembership?.name == 'Comprehensive'  ? 'tick.svg' : 'orange-gradient-tick.svg'}}"
          alt="">
        Save 15%+ with annual plans
      </div>
    </div>

    <div *ngIf="!isDiscounted" class="row">
      <div *ngIf="showAddOns" class="col-md-12 optional-addons-row d-flex">
        <div class="col-xs-12">
          <span class="show-addon-text">Optional Add-ons:</span>
        </div>
        <div class="col-xs-12 dental-vision">
          <div class="d-flex align-items-center rememberme-checkbox-div" style="gap: 10px;">
            <input type="checkbox" [(ngModel)]="hasDentalVision" (change)="updateMembershipTypeOnChange()"
              id="rememberme-checkbox" name="rememberme-checkbox" class="rememberme-checkbox">
            <label class="rememberme-text" for="rememberme-checkbox">Add Dental & Vision Benefits</label>
          </div>
        </div>
        <div class="col-xs-12 seperator-h">
          <!-- <div class="d-flex align-items-center rememberme-checkbox-div" style="gap: 10px;">
                <input type="checkbox" [(ngModel)]="hasReducePrimaryCare" (change)="updateMembershipTypeOnChange()" id="rememberme-checkbox" name="rememberme-checkbox" class="rememberme-checkbox">
                <label class="rememberme-text" for="rememberme-checkbox"> {{"MEMBERSHIP.REDUCE_IN_PERSON_LABEL" | translateIt: {language: sharedService.currentLanguage} | async }}</label>
            </div> -->
          <div *ngIf="!hideAnnualDiscount"
            [ngStyle]="{'opacity': pricingType?.toLowerCase() == 'monthly' || selectedMembership?.name == 'Comprehensive'? 0.3 : 1}"
            class="save15-desktop membership-packages-filter-description">
            <img width="16" height="16" style="margin-bottom: 3px;margin-right: 8px;"
              src="{{ sharedService.imagesUrl }}icons/{{pricingType?.toLowerCase() == 'monthly' || selectedMembership?.name == 'Comprehensive'  ? 'tick.svg' : 'orange-gradient-tick.svg'}}"
              alt="">
            Save 15%+ with annual plans
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="pricing-for-wow-plus-membership" class="pricing" [ngClass]="{'spin-overlay': isLoading}">
    <div *ngIf="isLoading" class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="all-options">
      <div *ngFor="let item of memberships" (click)="selectPackage(item)" class="WoW-Plus option"
        [ngClass]="{active: selectedMembership.id == item.id}">
        <div class="price-parent frequency-MONTHLY">
          <div class="radio-button">
            <input [(ngModel)]="selectedPackage" class="radio-button-input" type="radio" name="radio-button-input"
              value="wow-plus">

            <label class="radio-button-label" for="radio-button-input"></label>
          </div>
          <div class="name-price">
            <div class="offerName">{{ item.name }}
              <!-- Current Membership Label -->
              <span *ngIf="showCurrent && currentMembership && currentMembership.description == item.description"
                class="current">Current</span>
              <!-- Tooltip block   -->
              <span *ngIf="item.isComprehensive" class="comprehensive_info" onmouseleave="showTooltip(false)"
                onmouseover="showTooltip(true)"
                style="position: relative;margin-left: 5px;margin-top: -3px;bottom: 2px;">
                <img class="info_icon_block" [src]="IMAGES_URL + 'icons/info-circle.svg'" width="20" alt="">
                <div class="comprehensive_tooltip">
                  What is healthshare?<br>
                  <a href="/health-sharing/" class="learn-more">Learn More</a>
                </div>
              </span>

              <!-- <div class="info position-relative" *ngIf="item.isComprehensive" onmouseleave="showTooltip(false)"
                onmouseover="showTooltip(true)">
                <img class="info_icon_block" [src]="IMAGES_URL + 'icons/toltipe.svg'" width="20" alt="">

              </div> -->
            </div>
            <div class="regular-price" id="wowMembershipPrice-3257508">
              <span [ngClass]="{'price-cut': isDiscounted, 'sale-price': !isDiscounted }">
                ${{ isDiscounted ? item.originalPrice : item.price }}
                <span [ngClass]="{'month-year-label': !isDiscounted}"> {{ pricingType?.toLowerCase() == 'monthly' ?
                  '/mo' : '/yr' }}
                </span></span>
              <span *ngIf="isDiscounted" class="sale-price">{{ item.discountPrice }}</span>
            </div>
            <div *ngIf="item.hasDentalAndVision" class="dental-included">Includes: Dental & Vision</div>
          </div>
        </div>
      </div>



    </div>
    <div id="details" class="details" [ngClass]="{'single-membership': memberships?.length === 1}">

      <div *ngIf="isDiscounted" class="discount-tag">With ${{discountAmount}} Employer Credit</div>
      <div class="top-area-services">
        <h4 style="color: #191919;padding: 0px 0px 11px 13px;font-size: 16px; font-weight: 400;">Membership includes
        </h4>
        <div class="free-section" *ngIf="freeServices?.length">
          <img class="img-free" [src]="sharedService.imagesUrl +  'free.svg'">
          <p *ngFor="let item of freeServices">
            {{ item.title }}
            <span *ngIf="isDiscounted && item.desc"> - {{ item.desc }}</span>
          </p>
        </div>
      </div>
      <div class="checklistarea col-md-12">
        <!-- //minheight: 380 -->
        <div class="plus-col col-xs-10 col-md-10">

          <div *ngFor="let item of services" class="info-item">
            <span [innerHTML]="item.title"></span>
            <span *ngIf="isDiscounted && item.desc"> - {{ item.desc }}</span>
          </div>
        </div>
        <div class="checklist col-xs-2 col-md-2">
          <div class="tickes-main ms-auto" style="width: 59px;
            border-radius: 12px;
            background: #F3F3F3;
           
          ">
            <div *ngFor="let item of services" class="check-item item1"
              [ngClass]="{active: item.available, notavailable: !item.available}"></div>
          </div>
        </div>
      </div>

      <div *ngIf="selectedMembership?.footerDesc" class="member-notes">
        <em>
          <h4>
            <span class="highlight">
              {{ 'MEMBERSHIP.MEMBERNOTES_LABEL'
              | translateIt:{ language: sharedService.currentLanguage }
              | async }}
            </span>
            {{ selectedMembership?.footerDesc }}
          </h4>
        </em>
      </div>

    </div>
  </div>

  <!-- <div class="pricing-notes" >
    <span style="margin-right: 10px" class="not-available denta-vision-availablity">
      {{ note1 }}
    </span>
    <span style="margin-right: 10px" class="not-available denta-vision-availablity">
      **HealthShare is not available in WA  
      {{ note2 }}

      {{ note3 }}
    </span>
  </div> -->

  <div style="text-align: center;" class="mt-25 get-started-btn">
    <button (click)="goToPayment()" style="width: 250px;padding: 15px" [disabled]="isLoading"
      class="btn btn-primary payment-btn">{{btnLabel}}</button>
  </div>

</div>

<app-membership-modal (onModalClose)="getModalData($event)"></app-membership-modal>